"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@pasport/react-ui");
const tech_1 = require("../../../tech");
const useFetchBlob_1 = require("../../../tech/Blob/useFetchBlob");
const FileLink = ({ file, role, fetchFile }) => {
    //const {handleAnchorClick, isLoading} = useBlobUrl(file.url);
    const { handleAnchorClick, isLoading } = (0, useFetchBlob_1.useFetchBlob)((file.url !== undefined || file.path !== undefined)
        ? (() => (fetchFile ?? tech_1.fetchBlobByFile)(file))
        : undefined);
    // const {handleAnchorClick, isLoading} = useFetchBlob(
    //     () => fetchBlobByUrl("https://test-hrbitov.smsdata.cz/api/hrbitov/110/117/fileHrbitov")
    // );
    const addClass = role === 'button' ? "btn btn-dark px-3" : 'btn btn-link  link-dark p-2 ';
    return ((0, jsx_runtime_1.jsxs)("a", { className: "flex-grow-1 p-2 d-flex align-items-center gap-3 text-decoration-none " + addClass, href: "#", onClick: handleAnchorClick, children: [(0, jsx_runtime_1.jsx)("div", { children: isLoading ? ((0, jsx_runtime_1.jsx)(react_ui_1.LoadingIcon, { variant: 'small' })) : (file.type === 'image' ? ((0, jsx_runtime_1.jsx)("i", { className: "bi bi-image" })) : ((0, jsx_runtime_1.jsx)("i", { className: "bi bi-file-earmark-text" }))) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }, children: file.nazev })] }));
};
exports.default = FileLink;
